import { executeFunctionAfterHandler } from "@1js/acui-common";

export function getPropsWithMenuDismiss<
  T extends { onExecute?: (...args: any[]) => void }
>(props: T, dismissMenu: () => void): T {
  const rawProps = props as any;

  // Override the role if a roleInMenu is defined
  const updatedProps = {
    ...rawProps,
    role: rawProps.roleInMenu ?? rawProps.role ?? "menuitem",
  };
  return {
    ...updatedProps,
    onExecute: executeFunctionAfterHandler(props.onExecute, dismissMenu),
  };
}
